import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse,
    HttpHandler,
    HttpEvent
} from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { Observable, throwError } from "rxjs";
import { Injectable } from '@angular/core';
import { HaloLoaderService } from './core/halo-loader/halo-loader.service';
import { AuthenticationService } from './core/services/authentication.service';
import { CommonUtil } from './core/Utils/common-util';
import { AmplitudeAnalyticsService } from './core/services/amplitude-analytics.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(
        private loader: HaloLoaderService,
        private commonUtil: CommonUtil, 
        private authenticationService:AuthenticationService, 
        private _amplitudeAnalytics: AmplitudeAnalyticsService,
    ){
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add a custom header
        // Replace customReq in .handle(request).
        // const customReq = request.clone({
        //     headers: request.headers.set('app-language', 'it')
        // });
        return next
            .handle(request)
            .pipe(
                tap((ev: HttpEvent<any>) => {
                    //Here , we can able to output success http response;
                    if(request.method === 'DELETE' || request.method === 'POST' || request.method === 'PUT') {
                        this._amplitudeAnalytics.logEvent({elementName: request.url, action: 'API Call', additionalProperty: {status: 'Success', method: request.method}});
                    }
                }),
                catchError(response => {
                    if (response instanceof HttpErrorResponse) {
                        this._amplitudeAnalytics.logEvent({elementName: request.url, action: 'API Call', additionalProperty: {status: 'Error', method: request.method, errorCode: response.status}});
                        if(response.status === 401){
                            if(this.authenticationService.getAutoLogOutFlag() === false){
                                this.loader.resetProcess();
                                this.authenticationService.updateAutoLogOutFlag(true); 
                            } 
                        }
                    }
                    return throwError(response);
                })
            )
    }
}
